var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaby4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-266 -3015)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    transform: "translate(266 3015)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(217.964 3010.025)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64 15.926)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.38 25.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.345,332.1H320v-9.354a2.673,2.673,0,0,1,2.673-2.672h2.672Z",
    transform: "translate(-320 -320.074)",
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.38 37.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.013,466.747h-5.345a.668.668,0,0,1-.668-.668v-2h5.345a1.336,1.336,0,0,1,1.336,1.336v.668A.668.668,0,0,1,326.013,466.747Z",
    transform: "translate(-320 -464.074)",
    fill: "#ffbf9e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.681 25.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.354,320.074a6.681,6.681,0,0,0-6.681,6.681v2.672H144v4.009a1.336,1.336,0,0,0,1.336,1.336h4.009a5.345,5.345,0,0,0,5.345-5.345v-9.354Z",
    transform: "translate(-144 -320.074)",
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 34.087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.668,429.864h.668a1.336,1.336,0,0,0,1.336-1.336v-4.454h-2a.668.668,0,0,0-.668.668V429.2A.668.668,0,0,0,64.668,429.864Z",
    transform: "translate(-64 -424.074)",
    fill: "#ffd4be"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2.672 25.401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.354,320.074a6.681,6.681,0,0,0-6.681,6.681v2H96v4.677a1.336,1.336,0,0,0,1.336,1.336h4.009a5.345,5.345,0,0,0,5.345-5.345H110.7V332.1h5.345v-3.23a6.682,6.682,0,0,0,4.009-6.124v-2.672Z",
    transform: "translate(-96 -320.074)",
    fill: "#0cb2c2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.371 37.427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.013,466.747h-5.345a.668.668,0,0,1-.668-.668v-2h5.345a1.336,1.336,0,0,1,1.336,1.336v.668A.668.668,0,0,1,278.013,466.747Z",
    transform: "translate(-272 -464.074)",
    fill: "#ffd4be"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.38 22.729)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.672,
    cy: 2.672,
    r: 2.672,
    fill: "#0593ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.69 4.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M202.69,64.074a10.69,10.69,0,0,0,0,21.38H206.7a6.681,6.681,0,0,0,6.681-6.681V74.764A10.69,10.69,0,0,0,202.69,64.074Z",
    transform: "translate(-192 -64.074)",
    fill: "#ffd4be"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.367 14.711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.341,192.074v6.681a3.341,3.341,0,1,1,0-6.681Z",
    transform: "translate(-248 -192.074)",
    fill: "#ffbf9e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.716 14.711)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.002,
    cy: 1.002,
    r: 1.002,
    fill: "#463c4b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.345)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.002,
    cy: 1.002,
    r: 1.002,
    fill: "#463c4b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.38 18.052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322,233.41h-1.336a.668.668,0,1,1,0-1.336H322a.668.668,0,0,1,0,1.336Z",
    transform: "translate(-320 -232.074)",
    fill: "#ffbf9e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.734 18.052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,232.742a.668.668,0,0,0,.668.668h.635c.022-.22.033-.442.033-.668v-.668h-.668A.668.668,0,0,0,432,232.742Z",
    transform: "translate(-432 -232.074)",
    fill: "#ffbf9e"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(23.718 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.1,23.845h-.767a.334.334,0,0,1,0-.668h.767a4.249,4.249,0,0,0,4.244-4.244,2.341,2.341,0,0,0-2.338-2.338,1.672,1.672,0,0,0-1.67,1.67,1,1,0,0,0,1,1,.334.334,0,1,1,0,.668,1.672,1.672,0,0,1-1.67-1.67,2.341,2.341,0,0,1,2.338-2.338,3.01,3.01,0,0,1,3.007,3.007A4.918,4.918,0,0,1,349.1,23.845Z",
    transform: "translate(-348 -15.926)",
    fill: "#463c4b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaby4);
export default __webpack_public_path__ + "static/media/baby4.f6c2da5ab4424eb2786941fb16286ee8.svg";
export { ForwardRef as ReactComponent };